import { useEffect, useState } from "react";
import Banner from "./components/Banner/Banner";
import ReactGA from "react-ga4";

const WidgetContainer = () => {
  const [isWidgetLoaded, setIsWidgetLoaded] = useState(false);
  const [isEventSended, setIsEventSended] = useState(false);
  const { VITE_WIDGET_MOVILIDAD_PC_COMPONENTS_URL, PROD } = import.meta.env;

  useEffect(() => {
    if (!isWidgetLoaded) {
      const scriptDownloader = document.createElement("script");
      scriptDownloader.src = `${VITE_WIDGET_MOVILIDAD_PC_COMPONENTS_URL}/downloader.js`;
      document.body.appendChild(scriptDownloader);

      const widgetLoadedHandler = () => {
        const { eventBus, render } = weecoverWidget.default.widget("widget1");
        const parameters = window.location.search;
        render("ES", "TEST", parameters);
        setIsWidgetLoaded(true);
      };

      document.body.addEventListener("widget:loaded", widgetLoadedHandler);

      return () => {
        document.body.removeEventListener("widget:loaded", widgetLoadedHandler);
      };
    }
  }, [isWidgetLoaded, VITE_WIDGET_MOVILIDAD_PC_COMPONENTS_URL]);

  useEffect(() => {
    if (!isEventSended) {
      if (PROD) {
        ReactGA.send({
          hitType: "pageview",
          page: window.location.pathname,
          title: "Widget Page",
        });
        setIsEventSended(true);
      }
    }
  }, [isEventSended, PROD]);

  return (
    <div className="bg-white">
      {/* <Banner /> */}
      <div id="widget1"></div>
    </div>
  );
};

export default WidgetContainer;
